<template>
  <div class="demand" :class="classid == 1 ? 'cc' : ''">
    <div class="分类">
      <el-button :type="changecolor" @click="change(1)">需求商</el-button>
      <el-button :type="changecolore" @click="change(2)">供应商</el-button>
    </div>
    <hr style="margin: 20px 0; opacity: 0.5" />
    <!-- 查询、新增和删除操作 -->
    <el-form :inline="true" :model="demandQuery1" v-if="type === 1">
      <el-form-item>
        <el-input
          placeholder="请输入需求名称"
          width="100"
          v-model="demandQuery1.title"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item> </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getinfoinformain(1)">查询</el-button>
        <el-button type="warning" @click="chongzhi(1)">重置</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="demandQuery2" v-if="type === 0">
      <el-form-item>
        <el-input
          placeholder="请输入公司名称"
          width="100"
          v-model="demandQuery2.company"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item> </el-form-item>
      <el-form-item>
        <el-button  type="primary" @click="getDemandList2()">查询</el-button>
        <el-button type="warning" @click="chongzhi(2)">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="demandList" style="width: 100%" v-loading="loading" border>
      <el-table-column type="index" width="50" label="#" align="center">
      </el-table-column>

      <!-- <el-table-column
        v-if="type === 0"
        label="服务名称"
        prop="title"
        align="center"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.title) }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        v-if="type == 0"
        label="公司名"
        prop="companyName"
        align="center"
        width="200"
        show-overflow-tooltip
        key="1"
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.companyName) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="type == 1 ? '需求名称' : '服务名称'"
        prop="title"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.title) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="需求分类"
        prop="parentIdName"
        align="center"
        show-overflow-tooltip
        key="2"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.parentIdName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="type == 1"
        label="联系号码"
        prop="companyPhone"
        align="center"
        show-overflow-tooltip
        key="3"
      >
      </el-table-column>
      <!-- <el-table-column
        label="需求预算"
        align="center"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.price + "￥" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        v-if="type == 0"
        label="案例个数"
        prop="successCount"
        align="center"
        width="80"
        key="4"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.successCount">{{
            scope.row.successCount
          }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="type == 1 ? '需求描述' : '服务描述'"
        prop="description"
        align="center"
        width="200"
        show-overflow-tooltip
        key="5"
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.description) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="附件"
        prop="files"
        align="center"
        width="200"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
      <span>{{scope.row.files.split(',')[0]}}</span>
       <a v-if="scope.row.files" :href="scope.row.files.split(',')[0]">{{scope.row.files.split(',')[0]}}</a><br>
       <a v-if="scope.row.files !=null" :href="scope.row.files.split(',')[1]">{{scope.row.files.split(',')[1]}}</a><br>
       <a v-if="scope.row.files !=null" :href="scope.row.files.split(',')[2]">{{scope.row.files.split(',')[2]}}</a>
      </template>
      </el-table-column> -->
      <el-table-column
        v-if="type == 1"
        label="需求发布时间"
        prop="publishTime"
        align="center"
        key="6"
      >
      </el-table-column>
      <!-- <el-table-column
        v-else-if="type === 0"
        label="服务发布时间"
        prop="createTime"
        align="center"
        width="110"
      >
      </el-table-column> -->
      <el-table-column
        v-if="type === 1"
        label="需求完成时间"
        prop="endTime"
        align="center"
        key="7"
      >
        <!-- <template slot-scope="scope">
        <span v-if="scope.row.endTime">{{scope.row.endTime}}</span>
        <span v-else></span>
      </template> -->
      </el-table-column>
      <!-- <el-table-column
        label="承接时间"
        prop="supplyTime"
        align="center"
        width="110"
        v-if="type == 1"
      >
      </el-table-column> -->
      <!-- <el-table-column label="承接状态" align="center" width="110">
        <template slot-scope="scope">
          <span>{{ holdStatus(scope.row.status) }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        label="类型"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <el-tag
              size="small"
              :type="
                  scope.row.demandType == 0
                      ? ''
                      : 'success'
              "
          >
              {{
                  scope.row.demandType == 0
                      ? "招标"
                      : "雇佣"
              }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="是否可议价"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{isBargaining(scope.row.status)}}</span>
          <el-tag
              size="small"
              :type="
                  scope.row.isBargaining == 0
                      ? ''
                      : 'success'
              "
          >
              {{
                  scope.row.isBargaining == 0
                      ? "是"
                      : "否"
              }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="审核状态" align="center" width="110">
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="checkStyle(scope.row.verifyStatus)"
            disable-transitions
            @click="examineStatus(scope.row.id)"
          >
            {{ checkShow(scope.row.verifyStatus) }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- banner分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="totalCount"
      @current-change="pageChange"
      :page-size="demandQuery.limit"
      :current-page="demandQuery.page"
    >
    </el-pagination>
    <!-- 审核新添加列表的弹框 -->
    <check-status
      :check-query="checkQuery"
      ref="checkRef"
      @updateComputed="getinfoinformain()"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <!-- <add-or-update
            ref="addOrUpdate"
        ></add-or-update> -->
  </div>
</template>

<script>
import { checkMixin } from "@/utils/mixin.js";
import { showcontent } from "@/utils/method.js";
import CheckStatus from "@/views/modules/config/child-components/check-status-new";
export default {
  components: { CheckStatus },
  mixins: [checkMixin],
  data() {
    return {
      classid: 0,
      pd: 0,
      type: 1,
      changecolore: "",
      changecolor: "primary",
      // 需求列表
      demandList: [],
      // 获取需求列表参数
      demandQuery: {
        limit: 10,
        page: 1,
      },
      demandQuery1: {
        limit: 10,
        page: 1,
        title: "",
      },
      demandQuery2: {
        limit: 10,
        page: 1,
        company: "",
      },
      // 审核状态参数
      checkQuery: {
        id: null,
        checkStatus: "0",
      },
      // 需求总数
      totalCount: 0,
      loading: false,
    };
  },
  created() {
    // this.getDemandList();
    this.getinfoinformain();
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query.id == 1) {
      this.classid = 1;
    } else {
      this.classid = 0;
    }
  },
  computed: {
    holdStatus() {
      return (status) => {
        return status === "0"
          ? "未承接"
          : status === "1"
          ? "承接完成"
          : "已承接";
      };
    },
  },
  methods: {
    chongzhi(id){
      if(id == 1){
        this.demandQuery1.title = ''
        this.getinfoinformain()
      }else{
        this.demandQuery2.company = "";
        this.getDemandList2()
      }

    },
    change(v) {
      this.demandQuery1.title = "";
      this.demandQuery2.company = "";
      if (v === 2) {
        this.changecolore = "primary";
        this.changecolor = "";
        this.type = 0;
        this.getinfoinformain();
      } else {
        this.changecolor = "primary";
        this.changecolore = "";
        this.type = 1;
        this.getinfoinformain();
      }
    },
    getinfoinformain(id) {
      id == 1 ? (this.demandQuery.page = 1) : "";
      this.pd = 0;
      this.$ajaxPost("/companyServiceProvider/getPCInfo", {
        pageNo: this.demandQuery.page,
        pageSize: this.demandQuery.limit,
        orderRule: 1,
        serviceTypeId: null,
        serviceTypeParentId: null,
        type: this.type,
        platform: 1,
        title: this.demandQuery1.title,
      }).then(({ data }) => {
        if (data.code === 0) {
          console.log("企业需求", data);
          data.data.list.forEach((element) => {
            if (element.publishTime != null) {
              element.publishTime = element.publishTime.substring(0, 10);
            }
            if (element.supplyTime != null) {
              element.supplyTime = element.supplyTime.substring(0, 10);
            }
            if (element.endTime != null) {
              element.endTime = element.endTime.substring(0, 10);
            }
          });
          this.demandList = data.data.list;
          this.totalCount = Number(data.data.total);
          // this.loading = false;
        }
      });
    },
    showcontent,
    // 获取企业需求列表
    // getDemandList() {
    //   this.loading = true;
    //   this.$ajaxGet(
    //     "/company/list/pagesCompanyServiceList",
    //     this.demandQuery
    //   ).then(({ data }) => {
    //     if (data.code === 0) {
    //       console.log("企业需求", data);
    //       this.demandList = data.data.list;
    //       this.totalCount = data.data.total;
    //       this.loading = false;
    //       this.demandList.forEach((item) => {
    //         if (item.serviceTypeParentId === 1) {
    //           item.serviceTypeParentId = "品牌设计";
    //         } else if (item.serviceTypeParentId === 2) {
    //           item.serviceTypeParentId = "网站/软件";
    //         } else if (item.serviceTypeParentId === 3) {
    //           item.serviceTypeParentId = "直播服务";
    //         } else if (item.serviceTypeParentId === 4) {
    //           item.serviceTypeParentId = "营销推广";
    //         } else if (item.serviceTypeParentId === 5) {
    //           item.serviceTypeParentId = "知识产权";
    //         } else if (item.serviceTypeParentId === 41) {
    //           item.serviceTypeParentId = "文案翻译";
    //         } else if (item.serviceTypeParentId === 42) {
    //           item.serviceTypeParentId = "影视/动画";
    //         } else if (item.serviceTypeParentId === 43) {
    //           item.serviceTypeParentId = "电商网店";
    //         } else if (item.serviceTypeParentId === 44) {
    //           item.serviceTypeParentId = "建筑空间";
    //         } else if (item.serviceTypeParentId === 45) {
    //           item.serviceTypeParentId = "工业产品";
    //         }
    //       });
    //     }
    //   });
    // },
    // getDemandList1() {
    //   this.pd = 1;
    //   this.loading = true;
    //   this.$ajaxPost(
    //     `/company/getServiceByName?title=${this.demandQuery1.title}`,
    //     { limit: 10, page: this.demandQuery1.page }
    //   ).then(({ data }) => {
    //     if (data.code === 0) {
    //       this.demandList = data.data.list;
    //       this.totalCount = data.data.totalCount;
    //       this.loading = false;
    //       this.demandList.forEach((item) => {
    //         if (item.serviceTypeParentId === 1) {
    //           item.serviceTypeParentId = "品牌设计";
    //         } else if (item.serviceTypeParentId === 2) {
    //           item.serviceTypeParentId = "IT/软件";
    //         } else if (item.serviceTypeParentId === 3) {
    //           item.serviceTypeParentId = "直播服务";
    //         } else if (item.serviceTypeParentId === 4) {
    //           item.serviceTypeParentId = "营销宣传";
    //         } else if (item.serviceTypeParentId === 5) {
    //           item.serviceTypeParentId = "知识产权";
    //         }
    //       });
    //     }
    //   });
    // },
    getDemandList2() {
      this.pd = 2;
      this.loading = true;
      this.demandQuery2.page = 1;
      if (this.demandQuery2.company === "") {
        this.getinfoinformain();
          this.loading = false;
        return;
      }
      this.$ajaxPost(
        `/companyServiceProvider/getServiceByCompanyName?companyName=${this.demandQuery2.company}`,
        { limit: 10, page: this.demandQuery2.page }
      ).then(({ data }) => {
        if (data.code === 0) {
          this.demandList = data.data;
          this.totalCount = data.data.length;
          this.loading = false;
          this.demandList.forEach((item) => {
            if (item.serviceTypeParentId === 1) {
              item.serviceTypeParentId = "品牌设计";
            } else if (item.serviceTypeParentId === 2) {
              item.serviceTypeParentId = "IT/软件";
            } else if (item.serviceTypeParentId === 3) {
              item.serviceTypeParentId = "直播服务";
            } else if (item.serviceTypeParentId === 4) {
              item.serviceTypeParentId = "营销宣传";
            } else if (item.serviceTypeParentId === 5) {
              item.serviceTypeParentId = "知识产权";
            }
          });
        }
      });
    },
    // 分页器改变时触发事件
    pageChange(val) {
      this.demandQuery.page = val;
      this.demandQuery2.page = val;
      this.pd === 2 ? this.getDemandList2() : this.getinfoinformain();
    },
    // 审核商品状态
    examineStatus(id) {
      this.$nextTick(() => {
        this.$refs.checkRef.init(
          "/companyServiceProvider/verifyService",
          this.type,
          id
        );
      });
      // this.$nextTick(() => {
      //   this.$refs.checkRef.init(
      //     this.$ajaxGet('api/companyServiceProvider/verifyService',{
      //       type:this.type,
      //       serviceId:this.checkQuery.id,
      //       status:Number(this.checkQuery.checkStatus)
      //     }).then(({data})=>{
      //       if(data.code == 0){
      //         this.$message({
      //           title:'成功',
      //           type:'success',
      //           message:'审批成功'
      //         })
      //       }
      //     })
      //   );
      // });
    },

    // 通过 id 删除新闻
    deleteHandle(id) {
      this.$confirm("确定要删除该需求吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.type === 1){
            this.$ajaxGet('/companyServiceProvider/deleteService',{
              serviceId:id,
              type:'1'
            }).then(({ data }) => {
            if (data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              // this.getDemandList();
              this.getinfoinformain();
            } else {
              this.$message({
                type: "danger",
                message: data.msg,
              });
            }
          });
          }else{
            this.$ajaxGet(`/company/deleteById?id=${id}`).then(({ data }) => {
            if (data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              // this.getDemandList();
              this.getinfoinformain();
            } else {
              this.$message({
                type: "danger",
                message: data.msg,
              });
            }
          });
        }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style lang="less" scoepd>
.cc {
  background: #fff;
  padding: 20px;
  margin-top: -15px;
}
</style>